import React from 'react';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TreeItem from '@material-ui/lab/TreeItem';

import * as RequestCategories from '../../../../magic-strings/request-category';

const StandaloneRequestDetails = ({ reservationRequest }) => {

    return (
        <>
            <Paper className="detail-wrapper">
                <Typography variant="button" display="block" gutterBottom>
                    <b>Applied Offers for Request Categories</b>
                </Typography>
                <Divider />
                {
                    reservationRequest.requestApplicableCategories.indexOf(RequestCategories.Flight) >= 0 &&
                        reservationRequest.flightOffersResources.length > 0
                        ?
                        <CategoryOffers
                            label={"Flight Offers"}
                            categoryOffers={reservationRequest.flightOffersResources}
                            url={RequestCategories.Flight}
                        />
                        : null
                }
                {
                    reservationRequest.requestApplicableCategories.indexOf(RequestCategories.Visa) >= 0 &&
                        reservationRequest.visaOffersResources.length > 0
                        ?
                        <CategoryOffers
                            label={"Visa Offers"}
                            categoryOffers={reservationRequest.visaOffersResources}
                            url={RequestCategories.Visa}
                        />
                        : null
                }
                {
                    reservationRequest.requestApplicableCategories.indexOf(RequestCategories.Hotel) >= 0 &&
                        reservationRequest.hotelOffersResources.length > 0
                        ?
                        <CategoryOffers
                            label={"Hotel Offers"}
                            categoryOffers={reservationRequest.hotelOffersResources}
                            url={RequestCategories.Hotel}
                        />
                        : null
                }
                {
                    reservationRequest.requestApplicableCategories.indexOf(RequestCategories.Registration) >= 0 &&
                        reservationRequest.registrationOffersResources.length > 0
                        ?
                        <CategoryOffers
                            label={"Registration Offers"}
                            categoryOffers={reservationRequest.registrationOffersResources}
                            url={RequestCategories.Registration}
                        />
                        : null
                }
                {
                    reservationRequest.requestApplicableCategories.indexOf(RequestCategories.Transportation) >= 0 &&
                        reservationRequest.transportationOffersResources.length > 0
                        ?
                        <CategoryOffers
                            label={"Transportation Offers"}
                            categoryOffers={reservationRequest.transportationOffersResources}
                            url={RequestCategories.Transportation}
                        />
                        : null
                }
            </Paper>
        </>
    );
}

const CategoryOffers = ({ label, categoryOffers, url }) => {

    return (
        <>
            <Grid
                container
            >
                <Grid container item xs={12}>
                    <TreeView
                        defaultCollapseIcon={<ExpandMoreIcon />}
                        defaultExpandIcon={<ChevronRightIcon />}
                    >
                        <TreeItem nodeId="0" label={label}>
                            {
                                categoryOffers.map((offer, index) => (
                                    <TreeItem
                                        key={index}
                                        nodeId={`${index + 1}`}
                                        label={
                                            <Typography variant="body2" display="block" gutterBottom>
                                                <b>{offer.value} </b>
                                                <i>
                                                    <a
                                                        rel="noopener noreferrer"
                                                        href={`/offer/${url}/${offer.key}`}
                                                        target="_blank"
                                                        style={{ color: `#485dd4` }}
                                                    > see offer details</a>
                                                </i>
                                            </Typography>
                                        }
                                    />
                                ))
                            }
                        </TreeItem>
                    </TreeView>
                </Grid>
            </Grid>
        </>
    );
}

export default StandaloneRequestDetails;